import { diagnosticGutterExtension as e, setDiagnosticMarkers as t } from "./diagnostics-gutter.js";
import { trackingCodeEditorExtensions as n } from "./editor-theme.js";
import { useLayoutEffect as r, useMemo as i, useRef as a } from "react";
import { defaultKeymap as o, history as s, historyKeymap as c } from "@codemirror/commands";
import { html as l } from "@codemirror/lang-html";
import { Compartment as u, EditorState as d, Transaction as f } from "@codemirror/state";
import { EditorView as p, drawSelection as m, highlightActiveLine as h, highlightActiveLineGutter as g, keymap as _, lineNumbers as v } from "@codemirror/view";
//#region src/tracking-code-input/use-code-mirror-host.ts
function y(e) {
	return [d.readOnly.of(e), p.editable.of(!e)];
}
function b({ hostRef: b, value: x, onValueChange: S, diagnostics: C = [], readOnly: w = !1 }) {
	let T = a(null), E = a(S), D = a(x), O = a(C), k = a(w), A = i(() => new u(), []);
	return E.current = S, D.current = x, O.current = C, k.current = w, r(() => {
		let r = b.current;
		if (!r) return;
		let i = d.create({
			doc: D.current,
			extensions: [
				e,
				v(),
				m(),
				h(),
				g(),
				s(),
				l(),
				_.of([...o, ...c]),
				A.of(y(k.current)),
				...n,
				p.updateListener.of((e) => {
					if (!e.docChanged) return;
					let t = e.state.doc.toString();
					t !== D.current && E.current(t);
				})
			]
		}), a = new p({
			state: i,
			parent: r
		});
		return a.dispatch({ effects: t(O.current) }), a.requestMeasure(), T.current = a, () => {
			a.destroy(), T.current = null;
		};
	}, [b, A]), r(() => {
		let e = T.current;
		if (!e) return;
		let t = e.state.doc.toString();
		t !== x && e.dispatch({
			changes: {
				from: 0,
				to: t.length,
				insert: x
			},
			annotations: f.addToHistory.of(!1)
		});
	}, [x]), r(() => {
		let e = T.current;
		e && e.dispatch({ effects: t(C) });
	}, [C]), r(() => {
		let e = T.current;
		e && e.dispatch({ effects: A.reconfigure(y(w)) });
	}, [w, A]), T;
}
//#endregion
export { b as useCodeMirrorHost };
